export enum ImpairedCatalogItemsRoutes {
  Map = 'map',
  Passport = 'passport',
  Description = 'description',
  Table = 'datasetItems',
  Item = 'item'
}
